import yup from '../../../config/yup';

export const jsonArrayWriteValidationSchema = yup.object().shape({
  '@id': yup.string(),
  '@data-type': yup.string().default('format'),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('jsonArray'),
  properties: yup.object().shape({
    pretty: yup.boolean(),
  }),
});

export const jsonReaderSchema = yup.object().shape({
  '@id': yup.string(),
  '@data-type': yup.string().default('format'),
  name: yup.string().matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
    message:
      'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
  }),
  type: yup.string().default('jsonReader'),
});
